<template>
  <div ref="container" class="onhover" style="position: relative">
    <textarea
      ref="main"
      v-model="content_mutable"
      class="form-control"
      :name="name"
      :placeholder="placeholder"
      style="min-height: 200px"
    />
    <div
      class="onhover-show-visibility border border-top-0 border-end-0 bg-white ps-2 pe-2"
      style="position: absolute; top: 1px; right: 1px; cursor: pointer"
    >
      <a class="small text-muted clickable" @click.prevent="open_editor"
        >{{ translations.actions.CHANGE }} <icon name="ARROW_RIGHT"
      /></a>
    </div>
  </div>
</template>

<script lang="ts">
import icon from "@pdfking/workflow/components/icon"
import make_translations from "@pdfking/workflow/utils/make_translations"
import navigate from "../routes/navigate"
import { MARKDOWN_VIEW } from "../routes/urls"

export default {
  components: { icon },
  computed: {
    translations: () => make_translations("actions"),
  },
  data() {
    return {
      content_mutable: this.content,
    }
  },
  methods: {
    open_editor() {
      navigate(MARKDOWN_VIEW, {
        // @ts-expect-error - $refs.container is a template ref
        selector: `#${this.$refs.container.id} textarea`,
      })
    },
  },
  props: ["id", "name", "content", "cols", "rows", "placeholder"] as const,
}
</script>
